import { Link } from "react-router-dom";
import { Reveal } from "@/components/Motion";

const CONTENT = {
  privacy: { title: "Privacy Policy", body: [
    "This is placeholder privacy content for demonstration. Georgia Home Connect collects information you voluntarily submit through forms (name, email, phone, and property preferences) to respond to your real estate inquiries.",
    "We do not sell your personal information. Data may be shared with service providers strictly to facilitate your requests. You may request access to or deletion of your data at any time.",
    "Email & SMS communication: By opting in, you consent to receive calls, texts, and emails regarding your inquiry. Reply STOP to opt out of texts at any time.",
  ]},
  terms: { title: "Terms of Use", body: [
    "This is placeholder terms content for demonstration. By using this website you agree to use it for lawful purposes only.",
    "Property information & MLS/IDX: Listings displayed are sample/placeholder data and are not live MLS or IDX data. No third-party listing data is scraped or represented as live.",
    "Estimates: Mortgage, affordability, and home-value figures are educational estimates only and are not offers, approvals, or guarantees.",
    "AI-generated information: Some content may be generated or templated and should be independently verified.",
  ]},
  accessibility: { title: "Accessibility Statement", body: [
    "Georgia Home Connect is committed to providing a website that is accessible to the widest possible audience, in accordance with reasonable accessibility standards.",
    "We aim for meaningful color contrast, keyboard navigation, semantic HTML, and accessible form labels. If you experience any difficulty, please contact Richard so we can assist you.",
  ]},
  cookie: { title: "Cookie Policy", body: [
    "This is placeholder cookie content. This site may use cookies and similar technologies to improve your experience and, in the future, for analytics (e.g., Google Analytics) and marketing pixels (e.g., Meta Pixel). These are not required for the site to function.",
  ]},
};

export default function Legal({ page = "privacy" }) {
  const c = CONTENT[page] || CONTENT.privacy;
  return (
    <div className="bg-cream pt-28 pb-24 px-6 md:px-12 min-h-screen">
      <div className="max-w-3xl mx-auto">
        <Reveal><Link to="/" className="font-mono text-xs uppercase tracking-[0.2em] text-green hover:text-gold">← Home</Link></Reveal>
        <Reveal delay={0.1}><h1 className="font-serif text-5xl text-navy tracking-tighter mt-4 mb-3">{c.title}</h1></Reveal>
        <Reveal delay={0.15}><p className="text-charcoal/40 text-sm mb-10">Placeholder content — replace with reviewed legal language.</p></Reveal>
        <div className="space-y-5">
          {c.body.map((p, i) => <Reveal key={i} delay={i * 0.05}><p className="text-charcoal/75 leading-relaxed">{p}</p></Reveal>)}
        </div>
      </div>
    </div>
  );
}
